import { createApiClient, env } from '@botto/core';
import type { paths } from './generated/schema';

/**
 * SMS Routing API client.
 *
 * Regenerate types: `pnpm --filter @botto/module-sms generate:api`
 */
export const smsClient = createApiClient<paths>({
  baseUrl: env.smsApiUrl,
  audience: 'sms',
});
